module.exports = __webpack_public_path__ + "static/media/no_project.5aa8aa75.png";